import { Schema } from '../../../../adapters/schema';
import { asTypeProxy, makePathModel } from '../../../../utils/nestedPathModel';
import { MARITAL_STATUSES } from './formModel.types';
import { applicantSubformModel } from './ApplicantSubform/formModel';
var initialValues = {
    applicantsCount: 1,
    isSameHousehold: true,
    maritalStatus: MARITAL_STATUSES.MARRIED,
};
var fields = asTypeProxy();
var PATHS = {
    APPLICANTS_COUNT: fields.applicantsCount,
    APPLICANT: fields.applicant,
    APPLICANT_PHONE: fields.applicant.contact2.number,
    SECOND_APPLICANT: fields.secondApplicant,
    MARITAL_STATUS: fields.maritalStatus,
    IS_SAME_HOUSEHOLD: fields.isSameHousehold,
};
var _a = makePathModel(PATHS), paths = _a[0], selectors = _a[1];
var helpers = {};
var validationSchema = Schema.object({
    applicantsCount: Schema.number().required(),
    isSameHousehold: Schema.boolean().required(),
    applicant: applicantSubformModel.validationSchema,
    secondApplicant: Schema.object().when('applicantsCount', {
        is: 2,
        then: applicantSubformModel.validationSchema,
    }),
});
export var applicantPageModel = {
    paths: paths,
    selectors: selectors,
    helpers: helpers,
    initialValues: initialValues,
    validationSchema: validationSchema,
};
